import React, { useEffect, useMemo, useState } from 'react';
import { Card, CircularProgress, Link, Typography } from '@mui/material';
import { fetchReport } from '@api/report';
import { useSelector } from 'react-redux';
import { LampSvg } from '@assets/index';
import { useStyles } from './styles/ReportTips.styles';

import type { RootState } from '@features/redux/store';

interface ReportTipsProps {
    reportType: string;
}

export const ReportTips = ({ reportType }: ReportTipsProps) => {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [tips, setTips] = useState<{ [key: string]: string }>({});

    const { IdToken } = useSelector((state: RootState) => state.auth);

    const loadTips = async () => {
        setLoading(true);
        const tips = await fetchReport(reportType, IdToken as string);
        setTips(tips);
        setLoading(false);
    };

    const filterTips = (tips: string[]) => {
        return tips.filter((tip) => !tip.toLowerCase().includes('pruvia'));
    };

    useEffect(() => {
        loadTips();
    }, []);

    const filteredTips = useMemo(() => filterTips(Object.values(tips || {})), [tips]);

    return (
        <Card className={classes.root}>
            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        flexGrow: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 200,
                    }}>
                    <CircularProgress />
                </div>
            ) : !tips ? (
                <div
                    style={{
                        display: 'flex',
                        flexGrow: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 200,
                    }}>
                    <Typography style={{ fontStyle: 'italic', fontSize: 18 }}>
                        Cannot load the tips. Click
                        <Link className={classes.reloadLink} color="primary" onClick={loadTips}>
                            here
                        </Link>
                        to retry.
                    </Typography>
                </div>
            ) : (
                <React.Fragment>
                    <LampSvg className={classes.image} />
                    <ul>
                        {filteredTips.length === 0 ? (
                            <div style={{ fontSize: '16px' }}>No Tips Found!</div>
                        ) : (
                            filteredTips.map((tip) => (
                                <li key={tip}>
                                    <div className={classes.row}>{tip}</div>
                                </li>
                            ))
                        )}
                    </ul>
                </React.Fragment>
            )}
        </Card>
    );
};
